// Components
import { ButtonBase } from 'components/General/ButtonBase/ButtonBase';
import { CircleLoader } from 'components/General/Loader/Loader';
import TextField from 'components/General/TextField/TextField';

// uuid
import { v4 as uuid } from 'uuid';
import { setFilter, toggleFiltersModal } from '../StudentsSlice';
import { useLogic } from './Filters.logic';

// Style
import './Filters.scss';

export const Filters = ({ isLoading }: { isLoading: boolean }) => {
  const {
    studentsState,
    setSelectedFilter,
    dispatch,
    filters,
    setValue,
    value,
  } = useLogic();

  return (
    <div className="students-filters-container">
      {(studentsState.filter.userStatus || studentsState.filter.courses || studentsState.filter.search || studentsState.filter.country) && (
      <div className="filter-container selected">
        <ButtonBase
          tagName="div"
          onClick={() => {
            dispatch(setFilter({ courses: undefined, userStatus: undefined, search: undefined, country: undefined }));
            setValue('');
          }}
        >
          <p>Clear all</p>
        </ButtonBase>
      </div>
      )}
      {filters.map((filter) => (
        <ButtonBase
          tagName="div"
          onClick={() => {
            setSelectedFilter(filter.filter);
            dispatch(setFilter({ selectedFilter: filter.filter }));
            dispatch(toggleFiltersModal(true));
          }}
          key={uuid()}
        >
          <div className={`filter-container ${filter.active && 'selected'}`}>
            <p>{filter.filter}</p>
          </div>
        </ButtonBase>
      ))}
      <div className="search-filter-container">
        <TextField
          placeholder="Search"
          variant="rounded"
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      { isLoading && (
        <CircleLoader />
      )}
    </div>
  );
};
